import { FC, useEffect, useState, useCallback } from 'react';
import { useStyles } from './styles';
import { UseFormReturnType } from '@mantine/form';
import { DatePickerInput as DefaultDatePicker } from '@mantine/dates';
import { useTranslation } from 'react-i18next';
import 'dayjs/locale/ru';

interface IDatePickerProps {
  fieldName: string;
  form: UseFormReturnType<any>;
  className?: string;
  label?: string;
  disabled?: boolean;
  clearable?: boolean;
  placeholder?: string;
  withAsterisk?: boolean;
}

export const DatePicker: FC<IDatePickerProps> = ({
  form,
  fieldName,
  className,
  disabled,
  label,
  placeholder,
  withAsterisk,
  clearable = false
}) => {
  const { i18n } = useTranslation();
  const { classes, cx } = useStyles();
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey(Math.random());
  }, [form]);

  const handleDatePickerChange = useCallback(
    (value: Date | null) => {
      if (value) {
        const utcDate = new Date(Date.UTC(value?.getFullYear(), value.getMonth(), value.getDate()));
        const isoDate = utcDate.toISOString();
        form?.setFieldValue(fieldName, isoDate);
      } else {
        form?.setFieldValue(fieldName, null);
      }
    },
    [fieldName, form]
  );

  return (
    <DefaultDatePicker
      popoverProps={{ zIndex: 1400, withinPortal: false }}
      data-cy="datePicker"
      key={key}
      className={cx(classes.date, className)}
      locale={i18n.language}
      valueFormat="DD.MM.YYYY"
      placeholder={placeholder}
      label={label}
      disabled={disabled}
      clearable={clearable}
      defaultValue={
        form.getInputProps(fieldName)?.value?.length &&
        form.getInputProps(fieldName)?.value?.length !== null
          ? new Date(form.getInputProps(fieldName).value)
          : undefined
      }
      onChange={handleDatePickerChange}
      error={form.getInputProps(fieldName).error}
      maxDate={new Date()}
      withAsterisk={withAsterisk}
    />
  );
};
